import { labelStyle, groupStyle, focusStyle } from "./fieldStyles";

const NumberField = ({ formik, formClass, label, valueName, style, step = "0.01" }) => {
  return (
    <div style={{ ...groupStyle, ...style }}>
      <style>{focusStyle}</style>
      {label && <label htmlFor={valueName} style={labelStyle}>{label}</label>}
      <input
        id={valueName}
        className={`field-modern${formik.errors[valueName] ? " is-invalid" : ""}`}
        type="number"
        name={valueName}
        step={step}
        placeholder="0"
        value={formik.values[valueName] ?? ""}
        onChange={formik.handleChange}
      />
      {formik.errors[valueName] && (
        <span style={{ fontSize: "0.75rem", color: "#c62828", marginTop: "3px" }}>{formik.errors[valueName]}</span>
      )}
    </div>
  );
};

export default NumberField;
